export const staticPrimaryColor = '#78A9FF'
export const staticPrimaryDarkenColor = '#5E90E9'

export const staticPinkColor = '#F29D52'
export const staticPinkDarkenColor = '#DB8740'

export const themes = {
  light: {
    dark: false,
    colors: {
      primary: staticPrimaryColor,
      'on-primary': '#08101D',
      'primary-darken-1': staticPrimaryDarkenColor,
      pink: staticPinkColor,
      'pink-darken-1': staticPinkDarkenColor,
      secondary: '#5F6F86',
      'on-secondary': '#FFFFFF',
      'secondary-darken-1': '#4D5C72',
      success: '#38C793',
      'on-success': '#04140E',
      'success-darken-1': '#24AF7A',
      info: '#47B7E8',
      'on-info': '#05131A',
      'info-darken-1': '#309FCE',
      warning: '#F3BE59',
      'on-warning': '#1A1204',
      'warning-darken-1': '#DAA23F',
      error: '#EF6B73',
      'on-error': '#1A0508',
      'error-darken-1': '#D8565E',
      background: '#F3F5F9',
      'on-background': '#111827',
      surface: '#FFFFFF',
      'on-surface': '#0F1726',
      'surface-bright': '#FFFFFF',
      'surface-subtle': '#EDF2F7',
      'surface-muted': '#E5EBF3',
      'outline-muted': '#D1D9E6',
      'outline-strong': '#A6B3C7',
      'grey-50': '#F9FAFB',
      'grey-100': '#F3F5F8',
      'grey-200': '#E5E9F0',
      'grey-300': '#D2D9E4',
      'grey-400': '#B5C0CF',
      'grey-500': '#8A97AB',
      'grey-600': '#66758D',
      'grey-700': '#4A566B',
      'grey-800': '#2A3343',
      'grey-900': '#131A26',
      'grey-light': '#F6F8FB',
      'perfect-scrollbar-thumb': '#C9D4E3',
      'skin-bordered-background': '#F8FAFC',
      'skin-bordered-surface': '#FFFFFF',
      'expansion-panel-text-custom-bg': '#F6F8FB',
    },
    variables: {
      'code-color': '#275CCB',
      'overlay-scrim-background': '#060A12',
      'tooltip-background': '#0E1624',
      'overlay-scrim-opacity': 0.68,
      'hover-opacity': 0.07,
      'focus-opacity': 0.12,
      'selected-opacity': 0.1,
      'activated-opacity': 0.18,
      'pressed-opacity': 0.16,
      'dragged-opacity': 0.14,
      'disabled-opacity': 0.42,
      'border-color': '#111827',
      'border-opacity': 0.12,
      'table-header-color': '#EEF3F8',
      'high-emphasis-opacity': 0.94,
      'medium-emphasis-opacity': 0.72,
      'switch-opacity': 0.24,
      'switch-disabled-track-opacity': 0.34,
      'switch-disabled-thumb-opacity': 0.44,
      'switch-checked-disabled-opacity': 0.34,
      'track-bg': '#E3EAF5',
      'shadow-color': '#0A1020',
      'shadow-key-opacity': 0.14,
      'shadow-ambient-opacity': 0.02,
      'shadow-key-umbra-color': '#0A1020',
      'shadow-xs-opacity': 0.14,
      'shadow-sm-opacity': 0.16,
      'shadow-md-opacity': 0.18,
      'shadow-lg-opacity': 0.2,
      'shadow-xl-opacity': 0.24,
    },
  },
  dark: {
    dark: true,
    colors: {
      primary: staticPrimaryColor,
      'on-primary': '#08101D',
      'primary-darken-1': staticPrimaryDarkenColor,
      pink: staticPinkColor,
      'pink-darken-1': staticPinkDarkenColor,
      secondary: '#6C7C96',
      'on-secondary': '#F5F7FB',
      'secondary-darken-1': '#5A6982',
      success: '#42D29E',
      'on-success': '#04140E',
      'success-darken-1': '#27B883',
      info: '#61C1EB',
      'on-info': '#05131A',
      'info-darken-1': '#41A8D4',
      warning: '#F4C76A',
      'on-warning': '#1A1204',
      'warning-darken-1': '#DDB050',
      error: '#F17B82',
      'on-error': '#1A0508',
      'error-darken-1': '#D9656D',
      background: '#080C12',
      'on-background': '#EEF2F9',
      surface: '#111723',
      'on-surface': '#F5F7FB',
      'surface-bright': '#171F2D',
      'surface-subtle': '#0D131D',
      'surface-muted': '#151D2B',
      'outline-muted': '#263246',
      'outline-strong': '#3B4B65',
      'grey-50': '#0D121A',
      'grey-100': '#111723',
      'grey-200': '#171E2A',
      'grey-300': '#202938',
      'grey-400': '#2E3A4F',
      'grey-500': '#495873',
      'grey-600': '#73829B',
      'grey-700': '#A1AEC2',
      'grey-800': '#CDD6E3',
      'grey-900': '#F4F7FB',
      'grey-light': '#1A2230',
      'perfect-scrollbar-thumb': '#304056',
      'skin-bordered-background': '#0D121A',
      'skin-bordered-surface': '#111723',
      'expansion-panel-text-custom-bg': '#0D131D',
    },
    variables: {
      'code-color': '#8EB1FF',
      'overlay-scrim-background': '#03060D',
      'tooltip-background': '#0E1624',
      'overlay-scrim-opacity': 0.76,
      'hover-opacity': 0.08,
      'focus-opacity': 0.14,
      'selected-opacity': 0.12,
      'activated-opacity': 0.2,
      'pressed-opacity': 0.18,
      'dragged-opacity': 0.16,
      'disabled-opacity': 0.42,
      'border-color': '#F4F7FB',
      'border-opacity': 0.1,
      'table-header-color': '#141D2A',
      'high-emphasis-opacity': 0.96,
      'medium-emphasis-opacity': 0.76,
      'switch-opacity': 0.46,
      'switch-disabled-track-opacity': 0.38,
      'switch-disabled-thumb-opacity': 0.82,
      'switch-checked-disabled-opacity': 0.34,
      'track-bg': '#1B2433',
      'shadow-color': '#01040A',
      'shadow-key-opacity': 0.24,
      'shadow-ambient-opacity': 0.04,
      'shadow-key-umbra-color': '#01040A',
      'shadow-xs-opacity': 0.2,
      'shadow-sm-opacity': 0.24,
      'shadow-md-opacity': 0.28,
      'shadow-lg-opacity': 0.32,
      'shadow-xl-opacity': 0.38,
    },
  },
}

export default themes
